/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { translate } from "../translations/translations";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import BuyerIcon from "../../assets/icons/contract/toggleable/IconBuyer";
import SellerIcon from "../../assets/icons/contract/toggleable/IconSeller";
import vehicleMakes from "../vehicleMakes";
import { isMoney } from "../validationRules";
import LostPackageSvg from "../../assets/icons/contract/toggleable/IconLostPackage";
import QuestionMarkIcon from "../../assets/icons/common/toggleable/IconQuestionmark";
import CheckIcon from "../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../assets/icons/common/toggleable/IconClose";

export const vehicleContractFormDefinitions = {
  buyerOrSeller: buyerOrSeller,
  vehicleMake: vehicleMake,
  purchasePrice: purchasePrice,
  buyerPaidStatus: buyerPaidStatus,
  locationOfGood: locationOfGood,
  hasDefects: hasDefects,
  isAccidentCar: isAccidentCar,
  numberRepairAttempts: numberRepairAttempts,
  numberReplacementAttempts: numberReplacementAttempts,
};

function buyerOrSeller(values: AbstractCase) {
  return [
    {
      labelText: translate(`${values.name}.buyerOrSeller.options.buyer.label`, values),
      labelIcon: <BuyerIcon />,
      labelIconActive: <BuyerIcon active />,
      value: "buyer",
    },
    {
      labelText: translate(`${values.name}.buyerOrSeller.options.seller.label`, values),
      labelIcon: <SellerIcon />,
      labelIconActive: <SellerIcon active />,
      value: "seller",
    },
  ];
}

function vehicleMake() {
  return vehicleMakes;
}

function purchasePrice() {
  return {
    validators: [
      {
        validator: isMoney,
        message: "Bitte geben Sie den Wert in Euro und Cent ein - zum Beispiel 7500 oder 1350,50",
      },
    ],
  };
}

function buyerPaidStatus() {
  return {
    options: ["fully", "partially", "none"],
  };
}

function locationOfGood(values: AbstractCase) {
  return [
    {
      labelText: translate(`${values.name}.locationOfGood.options.buyer.label`, values),
      labelIcon: <BuyerIcon />,
      labelIconActive: <BuyerIcon active />,
      value: "buyer",
    },
    {
      labelText: translate(`${values.name}.locationOfGood.options.seller.label`, values),
      labelIcon: <SellerIcon />,
      labelIconActive: <SellerIcon active />,
      value: "seller",
    },
    {
      labelText: translate(`${values.name}.locationOfGood.options.elsewhere.label`, values),
      labelIcon: <LostPackageSvg />,
      labelIconActive: <LostPackageSvg active />,
      value: "elsewhere",
    },
    {
      labelText: translate(`${values.name}.locationOfGood.options.unknown.label`, values),
      labelIcon: <QuestionMarkIcon />,
      labelIconActive: <QuestionMarkIcon active />,
      value: "unknown",
    },
  ];
}

function hasDefects() {
  return [
    {
      labelText: "Ja",
      labelIcon: <CheckIcon />,
      labelIconActive: <CheckIcon active />,
      value: "yes",
    },
    {
      labelText: "Nein",
      labelIcon: <CrossIcon />,
      labelIconActive: <CrossIcon active />,
      value: "no",
    },
  ];
}

function isAccidentCar() {
  return [
    {
      labelText: "Ja",
      labelIcon: <CheckIcon />,
      labelIconActive: <CheckIcon active />,
      value: "yes",
    },
    {
      labelText: "Nein",
      labelIcon: <CrossIcon />,
      labelIconActive: <CrossIcon active />,
      value: "no",
    },
  ];
}

function numberRepairAttempts() {
  return {
    options: ["0", "1", "2", "3"],
  };
}

function numberReplacementAttempts() {
  return {
    options: ["0", "1", "2", "3"],
  };
}
